<template>
  <div class="page-identify-status">
    <el-dialog
      title="更新用户服务协议与隐私"
      custom-class="status-dialog"
      :visible="true"
      width="600px"
      :show-close="false"
      :modal="false"
      top="0"
    >
      <div class="title">更新内容</div>
      <div class="content-inner">
        感谢您使用智云问诊，我们尊重并保护您的个人隐私，若您使用本软件服务，将通过
        <span @click="goUserAgreement" class="blue pointer">《用户服务协议》</span>
        与
        <span @click="goPrivacyAgreement" class="blue pointer">《隐私权政策》</span>
        中双方的相关权利、义务条款来收集、存储、使用、共享和保护您的个人信息的条款，为确保您的个人权益不受侵害，请您仔细阅读，充分理解所有条款内容后再点击同意
      </div>
      <div slot="footer" style="textAlign:right">
        <el-button style="border-radius:0" @click="doAgree" type="primary">同意签署《用户隐私协议》</el-button>
        <el-button style="border-radius:0" @click="doRefund">拒绝</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/services';
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
  name: 'aggrement',
  data() {
    return {};
  },
  computed: {
    ...mapState('USER', {
      userInfo: state => state.userInfo
    })
  },
  async created() {},
  methods: {
    ...mapActions('USER', ['getUserInfo']),
    async doAgree() {
      await api.aggrement.signAgreement({
        agreementType: 'B2B_PURCHASER_AGREEMENT',
        signSourceType: 'PC'
      });
      this.$router.replace('/mallHomePage/all');
    },
    doRefund() {
      // todo
    },
    goUserAgreement() {
      window.open('https://static.kminghealth.com/kaer/buyerspc/index.html#/');
    },
    goPrivacyAgreement() {
      window.open('https://static.kminghealth.com/kaer/pc-privacy/index.html#/');
    }
  }
};
</script>

<style lang="scss" scoped>
.page-identify-status {
  height: 100%;
  background-image: url('https://static.kminghealth.com/attachment/20210929151439836_cf4ef3786b0241a1b97dbf3acd3fe4a0.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.status-dialog {
  margin-top: 0;
  vertical-align: middle;
  .title {
    line-height: 24px;
    font-size: 14px;
    font-weight: 400;
    color: #595959;
    text-align: center;
    margin-bottom: 16px;
  }
  .content-inner {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #595959;
    line-height: 24px;
    min-height: 120px;
    white-space: normal;
    text-align: left;
    text-indent: 2em;

    .blue {
      color: #1e8dff;
    }
  }
}
::v-deep .el-dialog__header {
  text-align: left;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #111111;
  line-height: 24px;
}
::v-deep .el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;
  &:after {
    content: ' ';
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
  .el-dialog {
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
